<h2 mat-dialog-title style="margin-bottom: 0px !important">
  <span>{{ 'form.setup_signing_unit' | translate }}</span>
  <button type="button" class="close" aria-label="Close" mat-dialog-close (click)="onNoClick()">
    <span aria-hidden="true">&times;</span>
  </button>
</h2>

<mat-divider></mat-divider>
<mat-dialog-content class="mat-typography" style="max-height: 65vh;margin-top: 15px;">
  <div class="mb-2">
    <strong>{{ 'enterprise_contract.lot_selected_document' | translate }}:</strong> {{ data.contractIds.length }}
  </div>

  <mat-expansion-panel class="mat-elevation-z0" expanded="true">
    <div class="d-flex align-items-end">
      <div style="padding-bottom: 1.5rem;">{{ 'enterprise_contract.select_sign_process' | translate }}</div>
      <mat-form-field class="mx-4" style="width: 20rem;">
        <mat-select name="procedure" id="procedure" [(ngModel)]="procedureId" (selectionChange)="changeProcedure($event)">
          <mat-option>
            <ngx-mat-select-search [formControl]="searchCtrl" [placeholderLabel]="'placeholder.search_procedure' | translate"
                                   [searching]="false" [noEntriesFoundLabel]="'analysis.no_data' | translate"></ngx-mat-select-search>
          </mat-option>
          <mat-option *ngFor="let option of proceduresFilter" [value]="option.id">
            {{ option.procedureName }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <div style="padding-bottom: 1.5rem;">{{ 'enterprise_contract.note_use_sign_process' | translate }}</div>
      <div [routerLink]="['/home-enterprise/procedure-management']" class="ml-1"
           style="color: #EE0033; text-decoration:underline; cursor: pointer; padding-bottom: 1.5rem;">
        {{ 'enterprise_contract.unit_signing_process' | translate }}
      </div>
    </div>

    <form nz-form>
      <nz-table #editRowTable [nzData]="listOfDataUserSign" [nzFrontPagination]="false" [nzShowPagination]="false"
                class="ant-table-no-placeholder-border-bottom no-ant-table-placeholder" nzBordered>
        <thead>
        <tr>
          <th class="text-center" nzWidth="54px" style="min-width: 54px;">
            {{ 'enterprise_contract.panel_document.table_parties.header.order' | translate }}
          </th>
          <th class="text-center" nzWidth="62%">
            {{ 'enterprise_contract.panel_document.table_users.header.name' | translate }}
          </th>
          <th class="text-center" nzWidth="130px" style="min-width: 130px;">
            {{ 'enterprise_contract.panel_document.table_users.header.role' | translate }}
          </th>
          <th class="text-center" nzWidth="100px" style="min-width: 100px;">
            {{ 'enterprise_contract.panel_document.table_users.header.CTS' | translate }}
          </th>
          <th nzWidth="54px" style="min-width: 54px;">&nbsp;</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let data of editRowTable.data; let i = index" class="editable-row">
          <td class="text-center">
            <nz-input-number class="td-nz-input" [(ngModel)]="data.order" (ngModelChange)="onChangeOrderApproveSign()"
                             [nzMin]="1" [nzMax]="999" [disabled]="data.userRole == '1'"
                             [ngModelOptions]="{ standalone: true }"></nz-input-number>
          </td>
          <td>
            <div *ngIf="data.userId != null" class="editable-cell">
              {{ data.userName }} - {{ data.userEmail }}
            </div>
          </td>
          <td class="text-center">
            <div *ngIf="data.userId != null">
              <nz-select [(ngModel)]="data.userRole" [ngModelOptions]="{ standalone: true }" style="width: 80%;"
                         (ngModelChange)="changeRoleUserSign($event, data)">
                <nz-option [nzLabel]="'form.contract_approval' | translate" [nzValue]="'2'"></nz-option>
                <nz-option [nzLabel]="'form.contract_sign' | translate" [nzValue]="'1'"></nz-option>
              </nz-select>
            </div>
          </td>
          <td *ngIf="data.userRole != '1'" class="td-nz-icon text-center">
            <label nz-checkbox [(ngModel)]="data.CTS" [ngModelOptions]="{ standalone: true }"
                   (ngModelChange)="changeCTS(data)"></label>
          </td>
          <td *ngIf="data.userRole == '1'"></td>
          <td class="td-nz-icon text-center">
            <a (nzOnConfirm)="onClickDeleteElementRecordUser(data)" *ngIf="data.userId != null" nz-popconfirm
               nzCancelText="{{ 'button.cancel' | translate }}" nzOkText="{{ 'button.ok' | translate }}"
               nzPopconfirmTitle="{{ 'popup.confirm_delete_user' | translate }}">
              <i aria-hidden="true" class="fa fa-trash" matTooltip="{{ 'tooltips.delete' | translate }}"></i>
            </a>
          </td>
        </tr>
        <tr class="editable-row">
          <td class="text-center">&nbsp;</td>
          <td>
            <div>
              <nz-input-group [nzSuffix]="suffixUserInput">
                <input #autocompleteInput (input)="onChangeUserSignSearch($event.target?.value)"
                       [(ngModel)]="inputUserValue" [ngModelOptions]="{ standalone: true }"
                       [nzAutocomplete]="autoUserSearching" id="inputUser" nz-input
                       placeholder="{{ 'placeholder.name_email_and_posiotion' | translate }}" />
                <nz-autocomplete #autoUserSearching>
                  <nz-auto-option (selectionChange)="autocompleteUserSelected($event, user)"
                                  *ngFor="let user of filteredUserOptions" [nzValue]="''">{{ user.fullName }}
                    - {{ user.email }} <span *ngIf="user.userPosition">- {{user.userPosition}}</span></nz-auto-option>
                </nz-autocomplete>
              </nz-input-group>
              <ng-template #suffixUserInput>
                <nz-spin [nzIndicator]="indicatorUserInput" [nzSpinning]="isLoadUserSign" nzSimple></nz-spin>
              </ng-template>
              <ng-template #indicatorUserInput><i class="nz-icon-font" nz-icon nzType="loading"
                                                  style="font-size: 24px"></i></ng-template>
            </div>
          </td>
          <td class="text-center">&nbsp;</td>
          <td class="td-nz-icon text-center">&nbsp;</td>
          <td class="td-nz-icon text-center">&nbsp;</td>
        </tr>
        </tbody>
      </nz-table>
      <mat-error *ngIf="isValidNoUserExist">
        {{ 'validation.error_user_no_set_up' | translate }}
      </mat-error>
      <mat-error *ngIf="isValidExistingSigning">
        {{ 'messages.error_no_user_sign' | translate }}
      </mat-error>
    </form>
  </mat-expansion-panel>
</mat-dialog-content>
<mat-divider></mat-divider>
<div class="text-center mt-3">
  <button mat-stroked-button color="primary" class="mr-3" (click)="onNoClick()">
    <mat-icon class="mr-0">cancel</mat-icon>{{ "button.cancel" | translate }}
  </button>
  <button mat-raised-button color="primary" [disabled]="isSaving" (click)="onsave()">
    <mat-icon class="mr-0">save</mat-icon>
    <span>{{ "enterprise_contract.lot_save_sign_flow" | translate }}</span>
  </button>
</div>
